import { useEffect } from 'react';
import IntercomSdk, {
  hide,
  onHide,
  onShow,
  show
} from '@intercom/messenger-js-sdk';

import { UserModel } from '@/models/UserModel';
import { ExacareFeature, FeatureFlagService } from '@/utils/featureFlagService';

export class Intercom {
  public static setUser(user: UserModel): void {
    if (!Intercom.isEnabled()) {
      return;
    }

    const payload = {
      app_id: 'w5jnvoxy',
      user_id: user.id,
      name: user.fullName,
      email: user.email,
      facility_id: user.facility_id,
      facility_name: user.user_facility_accesses?.find(
        (f) => f.facility_id === user.facility_id
      )?.facility?.name,
      user_role: user.user_type?.title,
      company: {
        company_id: user.organization_details?.id,
        name: user.organization_details?.name
      },
      alignment: 'left',
      hide_default_launcher: true
    };
    IntercomSdk(payload);
  }

  private static isEnabled(): boolean {
    return FeatureFlagService.isEnabled(ExacareFeature.INTERCOM);
  }
}
